import { ControlledTextInput } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { Dropdown } from '@sravni/react-design-system';
import type { SelectValue } from '@sravni/react-design-system/dist/types/components/Select';
import { useCallback, useState } from 'react';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

import type { TPassportFormFields } from 'entities/creditForm';

import { usePassportSuggestions } from 'features/UpdatePassportInfo/lib/usePassportSuggestions';

export const PassportIssuedBy: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { issuedByOptions: issuedBy } = usePassportSuggestions();
  const { setValue } = useFormContext<TPassportFormFields>();
  const validate = useValidateOnBlur(type);
  const [dropdownValue, setDropdownValue] = useState<SelectValue>();

  const handleOnSelect = useCallback(
    (value: SelectValue) => {
      if (value) {
        setValue('passportIssuedBy', value?.toString(), { shouldValidate: true });
        setDropdownValue(value);
      }
    },
    [setValue],
  );

  return (
    <Dropdown
      options={issuedBy}
      placement="bottom-start"
      matchWidth
      onChange={handleOnSelect}
      emptyContent={null}
      value={dropdownValue}
    >
      <div>
        <ControlledTextInput
          {...props}
          name={type}
          inputMode="text"
          onBlur={validate}
        />
      </div>
    </Dropdown>
  );
};
